var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1445,
    cy: 12,
    r: 12,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32453 16.6H9.12453V9.94H7.32453V16.6ZM8.22453 7C7.62453 7 7.14453 7.48 7.14453 8.08C7.14453 8.68 7.62453 9.16 8.22453 9.16C8.82453 9.16 9.30453 8.68 9.30453 8.08C9.30453 7.48 8.82453 7 8.22453 7ZM12.1845 10.96V9.94H10.3845V16.6H12.1845V13.18C12.1845 11.26 14.6445 11.14 14.6445 13.18V16.6H16.4445V12.52C16.4445 9.28 13.0245 9.4 12.1845 10.96Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.438e329eeb0e72870fe62c76a60f796e.svg";
export { ForwardRef as ReactComponent };